export default __webpack_public_path__ + "media/device-multiple.56dfe101.webp";